module.exports = __webpack_public_path__ + "static/img/info02@2x.648d4fcd.png";